function oxfordList(items) {
    if (typeof items === "string") {
        return items;
    }
    if (!items || !(Symbol.iterator in items)) {
        return "" + items;
    }
    items = Array.from(items).map(it => "" + it);
    if (items.length === 0) {
        return "";
    }
    if (items.length === 1) {
        return items[0];
    }
    if (items.length === 2 && items.join) {
        return items.join(" and ");
    }
    const last = items.pop();
    return items.join(", ") + ", and " + last;
}

export default oxfordList;



// WEBPACK FOOTER //
// ./app/lib/oxfordList.js